import { render, staticRenderFns } from "./CatIndex.vue?vue&type=template&id=4daf5648&scoped=true&"
import script from "./CatIndex.vue?vue&type=script&lang=js&"
export * from "./CatIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daf5648",
  null
  
)

export default component.exports